import { defineMessages } from 'react-intl';

/**
 * Strings for the SRP filter tape and its List | Map toggle (TEC navbar redesign Phase 2, items
 * 2.1/2.3/2.4), flag-gated (navbar_live_index). Deliberately separate ids from the classic
 * pill row's `filters.connector.and`/`filters.connector.or` (still "AND"/"OR", unchanged) rather
 * than lower-casing those shared strings in place: those ids are also used by
 * components/filters/TopFilters.tsx's flag-OFF renderer, and the flag-off path must stay
 * byte-for-byte identical to before this ticket. See the Phase 2 report's deviations section.
 */
export const tapeMessages = defineMessages({
  and: {
    id: 'nav.tape.and',
    defaultMessage: 'and',
    description: 'SRP filter tape: lowercase word joining two different filter attributes, e.g. "Helsinki and Full-time"',
  },
  or: {
    id: 'nav.tape.or',
    defaultMessage: 'or',
    description: 'SRP filter tape: lowercase word joining two OR\'d values of the same attribute inside one token, e.g. "Helsinki or Espoo"',
  },
  not: {
    id: 'nav.tape.not',
    defaultMessage: 'not',
    description: 'SRP filter tape: word before an excluded filter value, e.g. "not Barona"',
  },
  only: {
    id: 'nav.tape.only',
    defaultMessage: 'only',
    description: 'SRP filter tape: word before an exact-match ("only this value") filter value',
  },
  results: {
    id: 'nav.tape.results',
    defaultMessage: '{count} results',
    description: 'SRP filter tape: results count at the left end of the tape',
  },
  clearAll: {
    id: 'nav.tape.clearAll',
    defaultMessage: 'Clear all',
    description: 'SRP filter tape: visible label of the link that clears every active filter (distinct from filters.top.clearAll, which is an aria-only label on the classic pill row\'s icon button)',
  },
  quickAddPrefix: {
    id: 'nav.tape.quickAddPrefix',
    defaultMessage: '+ {label}',
    description: 'SRP filter tape: a suggested (not yet applied) filter value shown as a dashed "quick add" pill, e.g. "+ Espoo"',
  },
  sortNewest: {
    id: 'nav.tape.sortNewest',
    defaultMessage: 'newest first',
    description: 'SRP filter tape / index strip: muted note shown when sort is "Newest" (non-default)',
  },
  sortSalary: {
    id: 'nav.tape.sortSalary',
    defaultMessage: 'highest salary first',
    description: 'SRP filter tape / index strip: muted note shown when sort is "Salary" (non-default)',
  },
});

export const viewToggleMessages = defineMessages({
  list: {
    id: 'nav.view.list',
    defaultMessage: 'List',
    description: 'SRP List | Map toggle: list view segment label',
  },
  map: {
    id: 'nav.view.map',
    defaultMessage: 'Map',
    description: 'SRP List | Map toggle: map view segment label',
  },
});
